<script>
  let { children } = $props()
</script>

<tbody>
  {@render children?.()}
</tbody>